import { Button } from "@/components/ui/button"
import { Link } from "@inertiajs/react"
import { useMemo } from "react"

const CONFETTI_COLOURS = ["#C41E2A", "#D4A853", "#1A1A1A", "#E8E4DF", "#3A3A3C"]

function seededRandom(seed: number) {
  const x = Math.sin(seed + 1) * 10000
  return x - Math.floor(x)
}

export default function ReadyStep({ onComplete }: { onComplete: () => void }) {
  const particles = useMemo(
    () =>
      Array.from({ length: 20 }, (_, i) => ({
        left: seededRandom(i * 3) * 100,
        delay: seededRandom(i * 3 + 1) * 2,
        duration: 2 + seededRandom(i * 3 + 2) * 3,
        colour: CONFETTI_COLOURS[Math.floor(seededRandom(i * 7) * 5)],
      })),
    [],
  )

  return (
    <div className="text-center">
      {/* Celebration particles */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        {particles.map((p, i) => (
          <div
            key={i}
            className="absolute animate-confetti"
            style={{
              left: `${p.left}%`,
              top: "-10px",
              animationDelay: `${p.delay}s`,
              animationDuration: `${p.duration}s`,
            }}
          >
            <div
              className="size-2 rounded-full"
              style={{ backgroundColor: p.colour }}
            />
          </div>
        ))}
      </div>

      {/* Checkmark */}
      <div className="mx-auto mb-8 flex size-20 items-center justify-center rounded-full bg-red/10 opacity-0 animate-scale-in" style={{ animationDelay: "200ms", animationFillMode: "forwards" }}>
        <svg
          className="size-10 text-red"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2.5}
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m4.5 12.75 6 6 9-13.5"
          />
        </svg>
      </div>

      <h2 className="font-display text-4xl font-semibold tracking-tight text-charcoal sm:text-5xl opacity-0 animate-fade-in-up" style={{ animationDelay: "400ms", animationFillMode: "forwards" }}>
        You&apos;re all set
      </h2>
      <p className="mx-auto mt-4 max-w-md text-lg text-warm-grey opacity-0 animate-fade-in-up" style={{ animationDelay: "600ms", animationFillMode: "forwards" }}>
        Your account is ready. Time to create your first video ad.
      </p>

      <div className="mt-10 opacity-0 animate-fade-in-up" style={{ animationDelay: "800ms", animationFillMode: "forwards" }}>
        <Button
          onClick={onComplete}
          className="bg-red px-10 py-6 text-base font-semibold text-white hover:bg-red-deep"
        >
          Go to dashboard
        </Button>
      </div>

      <p className="mt-6 text-sm text-warm-grey opacity-0 animate-fade-in-up" style={{ animationDelay: "1000ms", animationFillMode: "forwards" }}>
        Or{" "}
        <Link href="/sign-up" className="text-charcoal underline-offset-4 hover:underline">
          invite your team first
        </Link>
      </p>
    </div>
  )
}
